import {getData} from "../api/get-data";
import {setCountCartHeader} from "../init-cart";
import {createButton} from "./create-button";
import {createDiv} from "./create-div";
import {createInput} from "./create-input";

export const createCounterElement = (className, countItem, itemId, onResolveHandler = () => {}) => {
  let count = +countItem;

  const wrapElement = createDiv(className);

  const deleteButtonElement = createButton(`–`, `counter__button counter__button--delete`);
  deleteButtonElement.title = `Удалить`;
  if (count === 1) {
    deleteButtonElement.disabled = true;
  }
  wrapElement.append(deleteButtonElement);

  const inputElement = createInput(`counter__input`, `number`, count);
  inputElement.min = 0;
  inputElement.max = 999;
  inputElement.readOnly = true;
  wrapElement.append(inputElement);

  const addButtonElement = createButton(`+`, `counter__button counter__button--add`);
  addButtonElement.title = `Добавить`;
  wrapElement.append(addButtonElement);

  addButtonElement.addEventListener(`click`, () => {
    inputElement.value = ++count;

    if (count !== 1) {
      deleteButtonElement.disabled = false;
    }

    getData({
      [`set_cart`]: {
        [`item_id`]: itemId,
        [`action`]: `add`,
      }
    })
    .then((response) => {
      setCountCartHeader(response.cart_count);

      onResolveHandler(response);
    });
  });


  deleteButtonElement.addEventListener(`click`, () => {
    inputElement.value = --count;

    if (count === 1) {
      deleteButtonElement.disabled = true;
    }

    getData({
      [`set_cart`]: {
        [`item_id`]: itemId,
        [`action`]: `reduce`,
      }
    })
    .then((response) => {
      setCountCartHeader(response.cart_count);
      onResolveHandler(response);
    });
  });

  return wrapElement;
};
